export default __webpack_public_path__ + "static/circle-fern-decoration-sienna-8f5c198c7520eb51d70d571e0cde1859.webp";